import Component from './modal-header-text';
export default Component;
